import ListingController from '@/braun/Controllers/Listing';
import ListingCompareInitiator from '@/braun/Controllers/Listing/Compare/ListingCompareInitiator';
import ListingFilters from '@/braun/Controllers/Listing/ListingFiltersController';
import { initPlpBVZeroReviews } from '@/utils/Controllers/Bazaarvoice/BVZeroReviewsController';
import GTMComparisonTool from '@/utils/Controllers/GTM/Operations/ComparisonTool';

document.addEventListener('DOMContentLoaded', () => {
  ListingFilters();
  ListingController();
  ListingCompareInitiator();
  GTMComparisonTool();
  initPlpBVZeroReviews();
});
